export default "__VITE_ASSET__CM3KKPaU__"